import { Unit } from "uom";
// Viscosity
export var PascalSecond = Unit.createBase("PascalSecond", "Viscosity", "Pa·s");
//# sourceMappingURL=viscosity.js.map